import { appendTranslation, clearTranslations, updateTranslation } from '~/services/current-document/translations'
import { dbRowToTranslationVersion } from '~/helpers/database-conversions'
import Translation from '~/editor/translation/translation'
import { reportError } from '~/services/errors'
import { LoadTranslationsProps } from '~/services/current-document/loading/translations.interfaces'
import Page from '~/editor/page/page'
import { TranslationVersion } from '~/editor/translation/translation.interfaces'

const entryOverflows = (lastVersion: TranslationVersion): boolean => {
  const startPoint = lastVersion.startPoint
  return startPoint ? startPoint.y > 1 : false
}

const findRealPage = (entry: Translation, pages: Page[]) => {
  const lastVersion = entry.versions[entry.versions.length - 1]
  const startPoint = lastVersion.startPoint
  
  if (!startPoint) return entry.page
  
  const entryY_relativeToPage = startPoint.y * entry.page.image.getScaledHeight()
  const pageY = entry.page.image.getY()
  const entryY = entryY_relativeToPage + pageY
  
  for (let i = 0; i < pages.length; i++) {
    if(entryY < pages[i].image.getY()){
      return pages[i - 1]
    }
  }
  
  // If not found, return the last page
  return pages[pages.length - 1]
}

const loadTranslations = async ({ chapterData, translationsData, commentsData, currentDocument, setIsLoading }: LoadTranslationsProps) => {
  clearTranslations()
  
  currentDocument.loadPages(chapterData.pages.original).then(() => {
    // Reduce to unique translation uuids
    const uniqueIds = translationsData.reduce<string[]>((result, entry) => {
      if (!result.includes(entry.entry_id)) {
        result = result.concat(entry.entry_id)
      }
      return result
    }, [])

    uniqueIds.forEach(id => {
      // Group versions using their parent translation uuid
      const versions = translationsData
        .filter(entry => entry.entry_id === id)
        .map(entry => dbRowToTranslationVersion(entry))
        .sort((a, b) => (new Date(a.date).getTime() - new Date(b.date).getTime()))

      // Group comments using their parent translation uuid
      const comments = commentsData
        .filter(entry => entry.entry_id === id)

      // Get the last version of the translation
      const lastVersion = versions[versions.length - 1]

      // Get the page where the translation is
      const page = currentDocument.pages.find(page => page.id === lastVersion.pageId) ?? currentDocument.pages[0]

      // Create a new Translation object
      const translation = new Translation({
        id,
        versions,
        page,
        comments
      })

      // Create a new translations with its versions & comments
      appendTranslation(translation)
      
      // Check if entry overflows and find the real page
      if(entryOverflows(lastVersion)){
        const incorrectPageIndex = translation.page.index
        console.group('Overflowing Entry = ', translation.index)
        // Assign the correct page 
        console.log('Before Y = ', translation.startPoint?.y)
        translation.page = findRealPage(translation, currentDocument.pages)
        // Fix the startPoint and endPoint
        translation.updatePoints()
        console.log('After Y = ', translation.startPoint?.y)
        console.log('Replaced page', incorrectPageIndex, "with page", translation.page.index)
        console.groupEnd()

        updateTranslation(translation.id, {
          startPoint: translation.startPoint,
          endPoint: translation.endPoint,
          pageId: translation.page.id
        })
      }
    })
  }).catch(error => {
    reportError(error)
  }).finally(() => {
    setIsLoading(false)
  })
}

export {
  loadTranslations,
  entryOverflows,
  findRealPage
}